<template>
  <div class="simulation">
    
   
    <div class="simulation-tabs">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="练习试卷" name="practice">
          <div v-loading="loading" class="simulation-papers">
            <div class="practice-grid">
              <div v-for="paper in papers" :key="paper.id" class="practice-item">
                <div class="practice-card">
                  <div class="practice-status" :class="paper.isCompleted ? 'done' : 'todo'">
                    {{ paper.isCompleted ? '已完成' : '未完成' }}
                  </div>
                  <div class="practice-title">{{ paper.title }}</div>
                  <div v-if="paper.questionCountText" class="practice-count">{{ paper.questionCountText }}</div>
                  <div class="practice-actions">
                    <template v-if="paper.isCompleted">
                      <el-button class="action-btn filled" size="small" @click="viewResult(paper)">答题结果</el-button>
                      <el-button class="action-btn outlined" size="small" @click="startExam(paper.id)">再次答题</el-button>
                    </template>
                    <template v-else>
                      <el-button class="action-btn filled" size="small" @click="startExam(paper.id)">开始答题</el-button>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!loading && papers.length === 0" class="no-records">
              <el-empty description="暂无试卷" />
            </div>
          </div>
          <div v-if="total > queryParams.pageSize" class="pagination">
            <el-pagination
              layout="prev, pager, next"
              :total="total"
              :page-size="queryParams.pageSize"
              :current-page="queryParams.pageNum"
              prev-text="<"
              next-text=">"
              @current-change="handlePageChange"
            />
          </div>
        </el-tab-pane>
        
        <el-tab-pane label="模拟试卷" name="simulation">
          <div v-loading="loading" class="simulation-papers">
            <div class="paper-grid">
              <div v-for="paper in papers" :key="paper.id" class="paper-item">
                <div class="paper-card">
                  <div class="paper-cover">
                    <img v-if="paper.coverImage" class="cover-img" :src="paper.coverImage" alt="" />
                    <span v-else class="cover-empty">暂无封面</span>
                  </div>
                  <div class="paper-body">
                    <div class="paper-title-row">
                      <div class="paper-title">{{ paper.title }}</div>
                      <div class="paper-status" :class="paper.isCompleted ? 'done' : 'todo'">
                        {{ paper.isCompleted ? '已完成' : '未完成' }}
                      </div>
                    </div>
                    <div v-if="paper.questionCountText" class="paper-count">{{ paper.questionCountText }}</div>
                    <div class="paper-actions">
                      <template v-if="paper.isCompleted">
                        <el-button class="action-btn filled" size="small" @click="viewResult(paper)">答题结果</el-button>
                        <el-button class="action-btn outlined" size="small" @click="startExam(paper.id)">再次答题</el-button>
                      </template>
                      <template v-else>
                        <el-button class="action-btn filled" size="small" @click="startExam(paper.id)">开始答题</el-button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!loading && papers.length === 0" class="no-records">
              <el-empty description="暂无试卷" />
            </div>
          </div>
          <div v-if="total > queryParams.pageSize" class="pagination">
            <el-pagination
              layout="prev, pager, next"
              :total="total"
              :page-size="queryParams.pageSize"
              :current-page="queryParams.pageNum"
              prev-text="<"
              next-text=">"
              @current-change="handlePageChange"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    
    <!-- 抽题规则设置抽屉 -->
    <el-drawer
      title="抽题规则设置"
      :visible.sync="drawerVisible"
      size="30%"
      direction="rtl"
    >
      <div class="drawer-content">
        <div class="question-type">
          <el-checkbox v-model="questionTypes.single">单选题</el-checkbox>
          <el-input v-model.number="questionTypesCount.single" style="width: 100px; margin-left: 20px;">道</el-input>
        </div>
        <div class="question-type">
          <el-checkbox v-model="questionTypes.multiple">多选题</el-checkbox>
          <el-input v-model.number="questionTypesCount.multiple" style="width: 100px; margin-left: 20px;">道</el-input>
        </div>
        <div class="question-type">
          <el-checkbox v-model="questionTypes.judgment">判断题</el-checkbox>
          <el-input v-model.number="questionTypesCount.judgment" style="width: 100px; margin-left: 20px;">道</el-input>
        </div>
        <div class="question-type">
          <el-checkbox v-model="questionTypes.shortAnswer">问答题</el-checkbox>
          <el-input v-model.number="questionTypesCount.shortAnswer" style="width: 100px; margin-left: 20px;">道</el-input>
        </div>
        <div class="total-questions">
          共{{ totalQuestions }}道题
        </div>
        <div class="drawer-actions">
          <el-button type="primary" size="large" @click="startPractice">开始练习</el-button>
        </div>
      </div>
    </el-drawer>
    
    <!-- 成绩弹窗组件 -->
    <ScoreDialog
      :visible.sync="scoreDialogVisible"
      :project-name="selectedScore.projectName"
      :score="selectedScore.score"
      :exam-time="selectedScore.examTime"
      :passing-score="selectedScore.passingScore"
    />
  </div>
</template>

<script>
import ScoreDialog from '@/components/ScoreDialog.vue'
import { getMyPapers } from '@/api/examApi'
import { getHomeCategoryTree } from '@/api/courseApi'

export default {
  name: 'AppSimulation',
  components: {
    ScoreDialog
  },
  created() {
    this.loadCategories()
    this.loadPapers()
  },
  data() {
    return {
      activeTab: 'practice',
      loading: false,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 4,
        paperType: 3,
        categoryId: undefined,
        maxPrice: undefined,
        minPrice: undefined
      },
      categories: [],
      selectedCategory: [],
      papers: [],
      drawerVisible: false,
      scoreDialogVisible: false,
      currentPaperId: null,
      selectedScore: {
        projectName: '',
        score: 0,
        examTime: '',
        passingScore: 60
      },
      questionTypes: {
        single: true,
        multiple: false,
        judgment: false,
        shortAnswer: false
      },
      questionTypesCount: {
        single: 10,
        multiple: 0,
        judgment: 0,
        shortAnswer: 0
      }
    }
  },
  computed: {
    totalQuestions() {
      let total = 0
      for (const type in this.questionTypes) {
        if (this.questionTypes[type]) {
          total += this.questionTypesCount[type] || 0
        }
      }
      return total
    }
  },
  watch: {
    activeTab(val) {
      this.queryParams.paperType = val === 'practice' ? 3 : 2
      this.queryParams.pageNum = 1
      this.loadPapers()
    }
  },
  methods: {
    normalizePaper(paper) {
      const rawQuestionCount =
        paper.questionCount ??
        paper.questionNum ??
        paper.questionTotal ??
        paper.totalQuestions ??
        paper.totalQuestion ??
        paper.subjectCount ??
        paper.topicCount ??
        paper.questionSize
      const questionCountNum = Number(rawQuestionCount)
      const questionCount = Number.isFinite(questionCountNum) && questionCountNum > 0 ? questionCountNum : 0

      const statusText = String(
        paper.statusName ??
          paper.statusText ??
          paper.finishStatusName ??
          paper.completeStatusName ??
          paper.completionStatusName ??
          ''
      )
      const rawCompleted =
        paper.isCompleted ??
        paper.completed ??
        paper.finished ??
        paper.isFinish ??
        paper.isFinished ??
        paper.hasFinished ??
        paper.done ??
        paper.isDone
      const rawCompletedNum = Number(rawCompleted)
      const isCompleted =
        rawCompleted === true ||
        rawCompleted === 'true' ||
        rawCompleted === '1' ||
        (Number.isFinite(rawCompletedNum) && rawCompletedNum === 1) ||
        statusText.includes('已完成')

      return {
        id: paper.id,
        title: paper.paperName,
        duration: paper.duration,
        durationText: paper.duration ? `${paper.duration}分钟` : '',
        totalScore: paper.totalScore,
        scoreText: paper.totalScore ? `${paper.totalScore}分` : '',
        price: paper.price,
        isFree: !paper.price || paper.price === 0,
        coverImage: paper.coverImage || '',
        questionCount,
        questionCountText: questionCount ? `共${questionCount}题` : '',
        isCompleted,
        createTime: paper.createTime,
        raw: paper
      }
    },
    async loadCategories() {
      try {
        const res = await getHomeCategoryTree()
        if (res.code === 200) {
          this.categories = res.data || []
        }
      } catch (err) {
        console.error('获取分类失败', err)
      }
    },
    handleCategoryChange(val) {
      if (val && val.length > 0) {
        this.queryParams.categoryId = val[val.length - 1]
      } else {
        this.queryParams.categoryId = undefined
      }
    },
    handleFilter() {
      this.queryParams.pageNum = 1
      this.loadPapers()
    },
    resetFilter() {
      this.queryParams.categoryId = undefined
      this.queryParams.maxPrice = undefined
      this.queryParams.minPrice = undefined
      this.selectedCategory = []
      this.queryParams.pageNum = 1
      this.loadPapers()
    },
    async loadPapers() {
      if (this.loading) return
      this.loading = true
      try {
        const { pageNum, pageSize, paperType } = this.queryParams || {}
        const res = await getMyPapers({ pageNum, pageSize, paperType })
        if (res.code === 200) {
          const list = res.data.list || []
          this.papers = list.map(item => this.normalizePaper(item))
          this.total = Number(res.data.total) || 0
        } else {
          this.papers = []
          this.total = 0
          this.$message.error(res.message || '获取试卷列表失败')
        }
      } catch (err) {
        this.papers = []
        this.total = 0
        console.error(err)
        this.$message.error('获取试卷列表失败')
      } finally {
        this.loading = false
      }
    },
    backToCourses() {
      this.$emit('back-to-courses')
    },
    startExam(paperId) {
      const isPracticePaper = this.activeTab === 'practice' || Number(this.queryParams.paperType) === 3
      let returnPath = this.$route.fullPath
      if (this.$route.path.includes('/member-center/courses')) {
        if (returnPath.includes('?')) {
          if (!returnPath.includes('view=simulation')) {
            returnPath += '&view=simulation'
          }
        } else {
          returnPath += '?view=simulation'
        }
      }
      this.$router.push({
        path: isPracticePaper ? `/practice-detail/${paperId}` : `/exam-detail/${paperId}`,
        query: { returnPath }
      })
    },
    handlePageChange(pageNum) {
      this.queryParams.pageNum = pageNum
      this.loadPapers()
    },
    // 保留旧方法以防万一，或者清理掉
    openDrawRuleDrawer(paperId) {
       // 如果模拟试卷需要规则设置，可以在这里处理
       // 目前假设直接开始
       this.startExam(paperId)
    },
    viewResult(paper) {
      if (!paper || !paper.id) {
        this.$message.error('无法获取试卷信息')
        return
      }
      this.$router.push({
        path: '/paper-answer-result',
        query: {
          paperId: paper.id,
          source: 'simulation'
        }
      })
    },
    startPractice() {
      if (this.currentPaperId != null && this.currentPaperId !== '') {
        this.drawerVisible = false
        this.startExam(this.currentPaperId)
        return
      }
      this.drawerVisible = false
      this.$message.warning('请选择试卷')
    }
  }
}
</script>

<style lang="scss" scoped>
.simulation {
  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e8e8e8;

    .section-title {
      font-size: 20px;
      font-weight: bold;
    }
  }

  .filter-container {
    background: #f8f9fa;
    padding: 16px;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .filter-form {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    
    .el-form-item {
      margin-bottom: 0;
      margin-right: 24px;
    }
  }

  .price-range {
    display: flex;
    align-items: center;
  }

  .range-separator {
    margin: 0 8px;
    color: #909399;
  }

  .simulation-tabs {
    margin-top: 20px;
  }

  .simulation-papers {
    margin: 20px auto 0;
    max-width: 1600px;
    padding: 0 12px;
  }

  .drawer-content {
    padding: 20px 0;

    .question-type {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
    }

    .total-questions {
      margin: 20px 0;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
    }

    .drawer-actions {
      display: flex;
      justify-content: center;
      margin-top: 30px;
    }
  }
}

.pagination {
  display: flex;
  justify-content: flex-end;
  padding: 14px 0 4px;
}

.practice-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.practice-card {
  position: relative;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #eef0f6;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 18px 20px;
  min-height: 132px;
}

.practice-status {
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
}

.practice-status.done {
  background: #3E2CCD;
}

.practice-status.todo {
  background: #FF4433;
}

.practice-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
  padding-right: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.practice-count {
  margin-top: 8px;
  font-size: 12px;
  color: #FF4433;
}

.practice-actions {
  display: flex;
  gap: 16px;
  margin-top: auto;
  padding-top: 14px;
  flex-wrap: wrap;
}

.paper-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(520px, 1fr));
  gap: 20px;
}

.paper-card {
  position: relative;
  display: flex;
  background: #fff;
  border: 1px solid #eef0f6;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  min-height: 108px;
}

.paper-cover {
  width: clamp(140px, 20%, 180px);
  background: #f5f7fa;
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 12px;
}

.cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cover-empty {
  padding: 0 10px;
}

.paper-body {
  flex: 1;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 0;
}

.paper-title-row {
  position: relative;
  padding-right: 70px;
}

.paper-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.paper-status {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  flex-shrink: 0;
}

.paper-status.done {
  background: #3E2CCD;
}

.paper-status.todo {
  background: #FF4433;
}

.paper-count {
  margin-top: 6px;
  font-size: 12px;
  color: #FF4433;
}

.paper-actions {
  display: flex;
  gap: 16px;
  margin-top: auto;
  padding-top: 12px;
  flex-wrap: wrap;
}

.action-btn {
  padding: 8px 20px;
  border-radius: 4px;
  font-size: 12px;
  min-width: 100px;
}

.action-btn.filled {
  background-color: #3E2CCD;
  border-color: #3E2CCD;
  color: #fff;
}

.action-btn.filled:hover {
  background-color: #3325ad;
  border-color: #3325ad;
}

.action-btn.outlined {
  background-color: #fff;
  border-color: #3E2CCD;
  color: #3E2CCD;
}

.action-btn.outlined:hover {
  background-color: #f0f0f0;
}

@media (max-width: 1200px) {
  .practice-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .paper-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 768px) {
  .paper-card {
    min-height: 100px;
  }

  .paper-cover {
    width: 110px;
  }
}

::v-deep .el-tabs__item.is-active {
  color: #3E2CCD;
  font-weight: 600;
}

::v-deep .el-tabs__active-bar {
  background-color: #3E2CCD;
}
</style>
